var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h3',{staticStyle:{"color":"#337ab7","font-weight":"bold"}},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.back()}}},[_vm._v("Shipnity")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }